import { clsx } from 'clsx'
import * as React from 'react'

import { textVariants } from '@/components-latest/primitives/Text'

import Styles from './Textarea.module.scss'

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={clsx(
          Styles.textarea,
          className,
          textVariants({ variant: 'nextBody' })
        )}
        data-testid="textarea"
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = 'Textarea'

export default Textarea
